import React from 'react';

export default function SidePicture() {
  return <div className="side-picture"></div>;
}
